import React from 'react';
import PropTypes from 'prop-types';
import { Card, Spinner } from 'ui';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';

const GradingStationPreviousComments = ({ questionId }) => {
  const {
    data = {},
    loading,
    error,
  } = useFetch(routes.GRADES.QUESTION_FEEDBACK_COMMENTS(questionId));

  if (error) {
    throw new Error('Error fetching previous comments in grading station.');
  }

  const { question = {}, comments = [] } = data;
  const { subject = '' } = question;
  if (loading) {
    return (
      <div className="mt-48">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      <div className="PanelHeader">
        <h1 className="PanelHeader-title ff-ss c-brand-gray-darker">
          {t('progress.previous_comments')}
        </h1>
      </div>
      <div className="d-f mb-24 mt-24 ff-ss fd-c">
        <p className="fz-20">{`${t('progress.previous_grader')}:`}</p>
        <span className="c-navy-darker fz-24 fw-b pl-16 border-left-solid border-left-3 border-gray mt-12 mb-32">
          {subject}
        </span>
        {comments.map(c => {
          const { learnerName, updatedAtDate, content, id } = c;
          return (
            <Card
              className="Animated Animated--fadeIn mb-32 d-f f-d-r ff-ss"
              key={id}
            >
              <Card.Content className="w-fill d-f fd-c p-24">
                <div className="c-brand-gray-dark fz-16 lh-24 w-fill mb-12">
                  <span>{`${t(
                    'progress.feedback_for',
                  )} ${learnerName}, ${updatedAtDate}`}</span>
                </div>
                <span className="fz-20 lh-24">{content}</span>
              </Card.Content>
            </Card>
          );
        })}
      </div>
    </>
  );
};

GradingStationPreviousComments.propTypes = {
  questionId: PropTypes.number,
};

export default props => <GradingStationPreviousComments {...props} />;
